import { VotingAction } from '@hotjar/feedback/domain/common/Responses/VotingAction';
import type { Answer } from './Answer';

export function getAnswerForVote(vote: VotingAction | null): Answer {
  if (vote === VotingAction.UPVOTED) return true;
  if (vote === VotingAction.DOWNVOTED) return false;
  return null;
}

export function getVotingActionForAnswer(
  currentVote: VotingAction | null,
  answer: Answer,
): VotingAction | null {
  if (answer === true) {
    return VotingAction.UPVOTED;
  }
  if (answer === false) {
    return VotingAction.DOWNVOTED;
  }
  if (currentVote === VotingAction.UPVOTED) {
    return VotingAction.REMOVED_UPVOTE;
  }
  if (currentVote === VotingAction.DOWNVOTED) {
    return VotingAction.REMOVED_DOWNVOTE;
  }
  return null;
}
